<a
  class="img-fluid align-self-center ps-2"
  *wlGenericLink="{ value: { href: ecmpHeader()?.url } }"
>
  <img
    [src]="ecmpHeader().logo"
    [alt]="'partnerlogo ' + ecmpHeader().description"
  />
</a>
